import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels = {
  '/dashboard': 'Dashboard',
  '/front-desk': 'Front Desk',
  '/calendar': 'Calendar',
  '/reservations': 'Reservations',
  '/groups': 'Groups',
  '/housekeeping': 'Housekeeping',
  '/guests': 'Guests',
  '/night-audit': 'Night Audit',
  '/reports': 'Reports',
  '/settings': 'Settings',
  '/rate-plans': 'Rate Plans',
  '/channel-manager': 'Channel Manager',
  '/revenue-analytics': 'Revenue Analytics',
  '/staff': 'Staff',
  '/maintenance': 'Maintenance',
  '/audit-logs': 'Audit Logs',
  '/accounting': 'Accounting',
  '/communications': 'Communications',
  '/messaging': 'Messaging',
  '/addons': 'Add-ons',
  '/promo-codes': 'Promo Codes',
  '/user-management': 'User Management',
  '/dnr': 'Do Not Rent',
  '/forecasting': 'Forecasting',
  '/export-reports': 'Export Reports',
  '/advanced-analytics': 'Advanced Analytics',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const label = routeLabels[currentPath] || currentPath.replace('/', '').replace(/-/g, ' ');

  if (currentPath === '/dashboard') return null; // No breadcrumb on home

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-slate-500 mb-4">
      <Link to="/dashboard" className="flex items-center gap-1 hover:text-slate-700 transition-colors">
        <Home size={16} />
        <span>Dashboard</span>
      </Link>
      <ChevronRight size={14} className="text-slate-400" />
      <span className="text-slate-900 font-medium capitalize">{label}</span>
    </nav>
  );
};

export default Breadcrumbs;
